import React, { useEffect, useState } from 'react'

import { Button, CircularProgress, Icons } from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { useSelector } from 'react-redux'
import { roles } from 'utils/constants/roles'
import { FailContainer } from './styles'

export default (props) => {
  const { history } = props
  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.LIVENESS, handleLoading)
  }, [])

  function handleRetry() {
    history.replace('/liveness')
  }

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <FailContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h1>FALHA NO RECONHECIMENTO FACIAL</h1>
      <h4>Tente novamente atentando-se ao seguinte:</h4>

      <table className="tip">
        <tbody>
          <tr>
            <td colSpan={2}>
              <h4 style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>Ao fazer o reconhecimento facial:</h4>
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>Retire todos os acessórios, como óculos e chapéus.</td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              Escolha um local bem iluminado e <b>não fique contra a luz</b>.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              <b>Aproxime o rosto</b> até encaixá-lo perfeitamente na área
              marcada.
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h4 style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>Ao enviar a foto do documento:</h4>
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              Use um documento com foto recente, sem borrões, rasuras ou amassados.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              Retire a capa plástica.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              Certifique-se de que a foto ficou nítida e com os dados legíveis.
            </td>
          </tr>
        </tbody>
      </table>


      <Button onClick={handleRetry}>
        Tentar novamente
      </Button>
    </FailContainer>
  )
}
